import { StatusBadge } from "../StatusBadge";

export function PreservationView({ report, testId = "preservation-report" }) {
  if (!report) return null;
  return (
    <div className="panel p-6" data-testid={testId}>
      <div className="flex flex-wrap justify-between gap-3 mb-4">
        <div>
          <p className="eyebrow mb-1">Content-preservation report</p>
          <p className="text-sm text-slate-400">v{report.source_version.number} → v{report.result_version.number} · {report.expected_sections} expected sections, {report.result_sections} in result</p>
        </div>
        <StatusBadge status={report.overall} testId="preservation-overall" />
      </div>
      <p className="text-xs text-slate-500 mb-4">{report.method}</p>
      {report.global_issues?.map((x, i) => <p key={i} className="text-sm text-warn-300 mb-3" data-testid="preservation-global-issue">• {x.message}</p>)}
      <div className="divide-y divide-slate-800 border border-slate-800 rounded-lg">
        {report.chapters.map((c, i) => (
          <div key={i} className="p-3 text-sm" data-testid={`preservation-row-${i}`}>
            <div className="flex justify-between gap-3"><span className="text-slate-200 truncate">{c.title}</span>
              <span className="flex items-center gap-3 shrink-0"><span className="font-mono text-xs text-slate-500">{c.words_source} → {c.words_result} w</span><StatusBadge status={c.status} /></span></div>
            {c.issues.map((x, j) => <p key={j} className={`text-xs mt-1 ${x.level === "ERROR" ? "text-rose-300" : "text-warn-300"}`}>• {x.message}</p>)}
          </div>
        ))}
      </div>
    </div>
  );
}
